import $ from "jquery";
import "slick-carousel/slick/slick";

import "./js/hexagon-hero";
import "./js/hexagon-mini";
import "./js/collapse";
import "./js/vselect";
import "./js/aodSelect";
import "./js/trendSelect";
import "./js/formSubmit";
import "./js/line-chart";
import "./js/spider-chart";
import "./js/country-profile";
import "./js/data-archive";

import "./js/jvectormap/jquery-jvectormap.min.js";
import "./js/map/jquery-jvectormap-world-mill"; // Map file
import "./js/interactive-map";
import "./js/social-share";

import "./js/overview-attributes.js";
import "./js/auth.js";

import { copyToClipboard } from "./js/helper";

jQuery(function ($) {
  console.log("Ready dev 1.3");

  const baseUrl = $("#base-url").data("base-url");

  $('.menu .menu-item a:contains("GSoD Indices")').on("click", function (e) {
    e.preventDefault();

    const url = $(this).attr("href");

    window.open(url, "_blank");
  });

  $("#button-menu-toggle").on("click", function () {
    if ($("#mobile-menu").hasClass("active")) {
      $(this).removeClass("active");
      $("#mobile-menu").removeClass("active");
      $("#mobile-menu").fadeOut();
      $("body").removeClass("overflow-hidden");
    } else {
      $(this).addClass("active");
      $("#mobile-menu").addClass("active");
      $("#mobile-menu").fadeIn();
      $("body").addClass("overflow-hidden");
    }
  });

  // Add a class to style 'Country profiles' menu item in main nav
  $('.nav-desktop .menu-item a:contains("Country profiles")').addClass(
    "menu-has-dropdown"
  );
  $(
    '.nav-mobile .menu-item a:contains("Country profiles"), .nav-desktop .menu-item a:contains("Country profiles")'
  ).on("click", function (e) {
    e.preventDefault();
  });

  let cancel = false;

  // Hover to open Countries dropdown menu
  $('.nav-desktop .menu-item a:contains("Country profiles")').on(
    "mouseenter",
    function (e) {
      e.preventDefault();

      cancel = true;
      $("#dropdown-menu-countries").fadeIn();
      $(".nav-desktop .menu-item.menu-item--expanded ul.menu").fadeOut();
    }
  );

  $('.nav-desktop .menu-item a:not(:contains("Country profiles"))').on(
    "mouseenter",
    function (e) {
      $("#dropdown-menu-countries").fadeOut();
    }
  );

  $('.nav-desktop .menu-item a:contains("Country profiles")').on(
    "mouseleave",
    function (e) {
      e.preventDefault();

      cancel = false;
    }
  );

  $("#dropdown-menu-countries").on("mouseleave", function (e) {
    setTimeout(() => {
      if (!cancel) {
        $("#dropdown-menu-countries").fadeOut();
      }
    }, 250);
  });

  $(".nav-desktop .menu-item.menu-item--expanded").on(
    "mouseenter",
    function (e) {
      $(this).find("ul.menu").fadeIn();
      $("#dropdown-menu-countries").fadeOut();
    }
  );

  $(
    ".nav-mobile .menu-item.menu-item--expanded a, .nav-desktop .menu-item.menu-item--expanded a"
  ).on("click", function (e) {
    if ($(this).parent().hasClass("menu-item--expanded")) {
      e.preventDefault();
    }
  });

  $(".nav-desktop .menu-item.menu-item--expanded").on(
    "mouseleave",
    function () {
      $(this).find("ul.menu").fadeOut();
    }
  );

  // Hide menu when click outside of menu
  $(document).on("mouseup", function (e) {
    var container = $("#dropdown-menu-countries");

    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.fadeOut();
    }
  });

  // Tooltip for attributes
  $(".attribute-tooltip-hover").on("mouseenter", function () {
    const tooltip = $(this).attr("data-tooltip");
    const tt = $(this).find("img");
    const anchorElem = tt.length > 0 ? tt : $(this);

    $("body").append(
      '<div class="attribute-tooltip"><div class="tooltip-content">' +
        tooltip +
        "</div></div>"
    );

    $(".attribute-tooltip").css("top", anchorElem.offset().top);
    $(".attribute-tooltip").css(
      "left",
      anchorElem.offset().left + anchorElem.width() / 2
    );
  });

  $(".attribute-tooltip-hover").on("mouseleave", function () {
    $(".attribute-tooltip").remove();
  });

  // Tab control for drop-down countries menu (desktop)
  $("#dropdown-menu-countries .region-tab-toggle").on("click", function () {
    const idx = $(this).data("index");

    if ($(this).hasClass("global")) {
      return;
    }

    $("#dropdown-menu-countries .region-tab-toggle.active").removeClass(
      "active"
    );
    $(this).addClass("active");

    $("#dropdown-menu-countries .countries-menu-group.active").removeClass(
      "active"
    );
    $("#dropdown-menu-countries .countries-menu-group.group-" + idx).addClass(
      "active"
    );
  });

  // Move continent menu and countries list into mobile menu element
  $("#mobile-menu .menu .menu-item:nth-child(3)")
    .first()
    .append($("#continent-menu-mobile"));
  $("#mobile-menu").append($(".mobile-menu-countries-list"));

  // On continent clicked, open countries list
  $(".continent-menu-each-click").on("click", function () {
    const target = $($(this).data("target"));

    target.addClass("active");

    setTimeout(() => {
      target.addClass("show");
    }, 50);
  });

  // Close countries list and back to mobile menu
  $(".back-to-menu-click").on("click", function () {
    $(".mobile-menu-countries-list").removeClass("show");

    setTimeout(() => {
      $(".mobile-menu-countries-list").removeClass("active");
    }, 300);
  });

  // Country profile, expand body text when clicked on "Read more"
  if ($("#country-body").length > 0) {
    const cbElm = $("#country-body");
    const shortContent = cbElm.find(".country-body-content").html();
    const fullContent = $("#country-full-body").html();
    let och = cbElm.find(".country-body-content").height(); // Original content height
    cbElm.height(och);

    $("#country-full-body").remove();

    $("#country-body-read-more").on("click", function (e) {
      e.preventDefault();

      och = cbElm.find(".country-body-content").height();

      cbElm.find(".country-body-content").html(fullContent);

      const nh = cbElm.find(".country-body-content").height();
      cbElm.height(nh);

      setTimeout(() => {
        cbElm.height("auto");
      }, 600);

      $(this).hide();
      $("#country-body-read-less").show();
    });

    $("#country-body-read-less").on("click", function (e) {
      e.preventDefault();

      const ch = cbElm.find(".country-body-content").height(); // Current height
      cbElm.height(ch);

      setTimeout(() => {
        cbElm.height(och);
      }, 50);

      setTimeout(() => {
        cbElm.find(".country-body-content").html(shortContent);
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $("#country-body").offset().top,
          },
          1500
        );
      }, 100);

      $(this).hide();
      $("#country-body-read-more").show();
    });
  }

  // User navigation
  $(".user-nav").on("mouseenter", function (e) {
    $(this).find(".user-nav-menu").fadeIn();
    $(
      ".nav-desktop .menu-item.menu-item--expanded ul.menu, #dropdown-menu-countries"
    ).fadeOut();
  });

  $(".user-nav").on("mouseleave", function () {
    $(this).find(".user-nav-menu").fadeOut();
  });

  //get dem notes from idea
  // if ($('#democracy_notes_and_commentary').length > 0) {
  //   const settings = {
  //     // "url": "https://www.idea.int.developmentzone.co/api/blog/democracynotes",
  //     "url": "http://idea-aws.loc/api/blog/democracynotes",
  //     "method": "POST",
  //     // "timeout": 0,
  //     "headers": {
  //       "Content-Type": "application/json"
  //     },
  //   };

  //   $.ajax(settings).done(function (response) {
  //     console.log('hii')
  //     console.log({response})
  //   });
  // }

  // Slick sliders
  if ($(".gsod-post-slider").length > 0) {
    $(".gsod-post-slider").each(function () {
      const elm = $(this);
      const nav = $(elm.data("nav"));

      elm.slick({
        infinite: false,
        appendArrows: nav,
      });
    });
  }

  if ($(".gsod-page-slider").length > 0) {
    $(".gsod-page-slider").each(function () {
      const elm = $(this);
      const nav = $(elm.data("nav"));

      elm.slick({
        infinite: false,
        appendArrows: nav,
        // adaptiveHeight: true,
      });

      $(elm.data("nav") + " button:first-child").after(
        '<span class="font-aileron font-bold text-xs uppercase">1 of ' +
          elm.slick("getSlick").slideCount +
          "</span>"
      );

      elm.on("afterChange", function (datak, data) {
        nav.find("span").text(data.currentSlide + 1 + " of " + data.slideCount);
      });
    });
  }

  if ($(".even-card-report-description").length > 0) {
    $(".even-card-report-description a").on("click", function (e) {
      e.preventDefault();

      const url = $(this).attr("href");
      window.open(url, "_blank");
    });
  }

  $(".link-tag.data-archive").on("click", function (e) {
    e.preventDefault();

    const id = $(this).data("id");

    window.location = baseUrl + "searchable-archive?tag=" + id;
  });

  // Smooth scrolling to anchor #
  $("a[href*=\\#]:not([href=\\#])").click(function () {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html,body").animate(
          {
            scrollTop: target.offset().top,
          },
          1000
        );
        return false;
      }
    }
  });

  $("#button-close-message-banner").on("click", function () {
    $(this).parent().remove();
  });

  $(".open-link-in-new-tab").on("click", "a", function (e) {
    const url = $(this).attr("href");

    if (url.indexOf("http") >= 0) {
      e.preventDefault();
      window.open(url, "_blank");
    }
  });

  $(".button-open-modal").on("click", function () {
    const target = $(this).data("target");

    $("#overlay-mask").fadeIn();
    $(target).fadeIn();
  });

  $(".button-close-modal").on("click", function () {
    const target = $(this).data("target");

    $("#overlay-mask").fadeOut();
    $(target).fadeOut();
  });

  // Copy to clipboard ///////////////////////////////////////
  $(".copyToClipboard").on("click", function () {
    const url = $(this).data("url");
    const tooltipElement = `<div class="copyToClipboard-tooltip font-aileron bg-white text-gsodBody rounded drop-shadow-tooltip p-3 text-center text-xs
      whitespace-nowrap absolute -top-4 left-[60%] -translate-x-1/2 -translate-y-full
      before:content-[''] before:block before:w-3 before:h-3
      before:absolute before:left-1/2 before:bottom-0
      before:-translate-x-1/2 before:translate-y-1/2 before:rotate-45 before:bg-inherit"
    >Copied to clipboard!</div>`;

    const successCallback = () => {
      $(this).parents(".copyToClipboard-wrapper").append(tooltipElement);
      setTimeout(() => {
        $(".copyToClipboard-tooltip").remove();
      }, 3000);
    };

    copyToClipboard(url, successCallback);
  });

  // Radio form collapsible list ///////////////////////////////////////
  $(".gsod-radio-vcollapse .vcollapse-content").each(function () {
    $(this).hide();
  });

  $(".gsod-radio-vcollapse .vcollapse-toggle").on("click", function () {
    const target = $($(this).data("target"));

    if (target.hasClass("vcollapse-content")) {
      target.slideToggle();
      $(this).find("img").toggleClass("rotate-180");
    }
  });

  $(".framework-tt")
    .on("mouseenter", function () {
      console.log($(this).find(".framework-tt-full"));
      $(this).find(".framework-tt-full").css("opacity", 1);
      $(this).css("width", 200);
    })
    .on("mouseleave", function () {
      $(this).css("width", 60);
      $(this).find(".framework-tt-full").css("opacity", 0);
    });
});
// Document.ready END
///////////////////////////////////////////////////////////////////////////////
